import NotFound from 'components/shared/NotFound';
import React from 'react';
import { Route, Routes } from 'react-router-dom-v5-compat';

import New from './New';

function Session() {
  return (
    <Routes>
      <Route path="new" element={<New />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Session;
